<template>
  <div class="batchremove">
    <h3 class="tip">
      <i></i>
      <span>{{$t('msg.m10')}}</span>
    </h3>
    <div>
      <Datatable
        :th="[$t('label.w96'),$t('label.w160'),$t('label.w195'),$t('label.w162')]"
        v-slot="{item}"
        :static="datalist"
        :tip="$t('msg.m100')"
      >
        <tr>
          <td>{{item.Name}}</td>
          <td>{{item.OperatorName}}</td>
          <td>{{item.OperatorAccount}}</td>
          <td>{{item.OperatorVerifyInfo}}</td>
        </tr>
      </Datatable>
    </div>
    <div class="agree">
      <Checkbox v-model="agree">{{$t('other.w63')}}</Checkbox>
      <span @click="protocolShow([8])">{{$t('other.w117')}}</span>
    </div>
    <div class="confirm">
      <span @click="back">{{$t('btn.b17')}}</span>
      <span @click="submit">{{$t('btn.b12')}}</span>
    </div>
    <Protocol ref="Protocol" @yes="agree=true" @no="agree=false"/>
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import Protocol from "@/components/protocolModal";
export default {
  components: { Datatable, Protocol},
  data(){
    return {
      agree:false,
      datalist:[],
    }
  },
  mounted(){
    let ids=this.$route.params.ids
    if(ids){
      this.$axios.post('/Member/RZJPledge/SelectBatchPledgeList',{
        pledgeIds:ids
      })
      .then(res=>{
        if(res.err) return this.back()
        this.datalist=res
      })
    }else{
      this.back()
    }
  },
  methods:{
    back(){
      this.$router.replace({name:'domainManage'})
    },
    async submit(){
      if (!this.agree) return this.$Message.error(this.$t('msg.m63'));
      let res=await this.$axios.post('/Member/RZJPledge/BatchApplyPledge',{
        pledgeIds:this.$route.params.ids
      })
      res.throw()
      if(!res.err) this.back()
    },
     protocolShow(arr){
      this.$refs.Protocol.type=arr
      this.$refs.Protocol.modal=true
    }
  }
};
</script>

<style lang="less" scoped>
.batchremove {
  .tip {
    display: flex;
    align-items: center;
    margin: 30px 0;
    padding-left: 20px;
    line-height: 40px;
    width: 1200px;
    height: 40px;
    background: rgba(255, 251, 230, 1);
    border-radius: 4px;
    border: 1px solid rgba(255, 229, 143, 1);
    font-size: 14px;
    vertical-align: middle;
    color: rgba(0, 0, 0, 0.85);
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      background: url("../../assets/security/public_message.png") no-repeat;
      background-size: cover;
      background-position: -14px 0px;
      margin-right: 5px;
    }
  }

  .agree {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    margin-top: 20px;
    .ivu-checkbox-wrapper {
      margin-right: 0;
      color: rgba(123, 123, 124, 1);
      font-size: 14px;
    }
    span {
      color: #5e8ffc;
      cursor: pointer;
    }
  }
  .confirm {
    display: flex;
    justify-content: flex-end;
    margin: 30px 0;
    span {
      cursor: pointer;
      display: inline-block;
      width: 120px;
      height: 40px;
      border: 1px solid rgba(123, 123, 124, 1);
      border-radius: 20px;
      line-height: 40px;
      color: #7b7b7c;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
    }
    span:last-child {
      background: rgba(94, 143, 252, 1);
      color: rgba(255, 255, 255, 1);
      border-color: #5e8ffc;
      margin-left: 20px;
    }
  }
}
</style>
